import logo from './logo.svg';
import './App.css';

function App({ children }) {
  return (
    <div>
      {children}</div>
  );
}

export default App;
